
import { apiSlice } from './apiSlice';
const USERS_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1`;
// const USERS_URL = process.env.REACT_APP_BACKEND_URI;


export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth/login`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/auth/logout`,
        method: 'POST',
        credentials: "include",
      }),
    }),
    register: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth/register`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth/forgotPassword`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    passwordReset: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth/resetpassword`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    updateUser: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth/profile`,
        method: 'PUT',
        body: data,
        credentials: "include",
      }),
    }),
    getSub: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth/getsub`,
        method: 'GET',
        credentials: "include",
      }),
    }),
    getAdminDashboardStats: builder.query({
      query: () => ({
        url: `${USERS_URL}/auth/dashboard/getAdminDashboardStats`,
        method: 'GET',
        credentials: 'include',
      }),
    }),
    getCourse: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/admin/course/getallcourse`,
        method: 'GET',
        credentials: "include",
      }),
    }),
    getCecmas: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth/cecmas`,
        method: 'GET',
        credentials: "include",
      }),
    }),
    kiteProfile: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/auth/kite-profile`,
        method: 'GET',
        credentials: "include",
      }),
    }),

    getZerodhaHolding: builder.query({
      query: () => ({
        url: ` ${USERS_URL}/zerodha-holding`,
        method: 'GET',
        credentials: 'include', // needed for cookies
      }),
    }),

    getShortTermPositions: builder.query({
      query: () => ({
        url: `${USERS_URL}/getShortTermPositions`,
        method: 'GET',
        credentials: 'include',
      }),
    }),

    getOrderHistory: builder.query({
      query: (orderId) => ({
        url: `${USERS_URL}/getOrderHistory/${orderId}`,
        method: 'GET',
        credentials: 'include',
      }),
    }),

    logoutZerodha: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout-zerodha`,
        method: 'POST', // assuming you are sending a POST request to log out
        credentials: "include",

      }),

    }),

    getAngelProfile: builder.query({
      query: (userId) => ({
        url: `${USERS_URL}/angel-one/get-angelone-profile`,
        method: 'GET',
        credentials: "include",
      }),
    }),

    getClientIdStatus: builder.query({
      query: (clientId) => ({
        url: `${USERS_URL}/auth/check-clientId`,
        method: 'GET',
        credentials: "include", // important if you're using cookies
      }),
    }),
    updateClientId: builder.mutation({
      query: (clientId) => ({
        url: `${USERS_URL}/user/update-clientId`,
        method: 'PUT',
        body: { clientId },
        credentials: 'include',
      }),
    }),

getDownlineUser: builder.query({
  query: () => ({
    url: `${USERS_URL}/auth/downline`,
    method: 'GET',
    credentials: "include",
  }),
}),
getBankDetails: builder.query({
  query: () => ({
    url: `${USERS_URL}/payments/get-bank-details`,
    method: 'GET',
    credentials: "include",
  }),
}),
getLoginUser: builder.query({
  query: () => ({
    url: `${USERS_URL}/auth/getuser`,
    method: 'GET',
    credentials: "include",
  }),
}),
  saveBankDetails: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/payments/save-bank-details`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    
  }),
});

// Export hooks for usage in components
export const {
  useGetLoginUserQuery,
  useGetDownlineUserQuery,
  useLoginMutation,
  useLogoutMutation,
  useRegisterMutation,
  useUpdateUserMutation,
  useForgotPasswordMutation,
  usePasswordResetMutation,
  useGetSubMutation,
  useGetCourseMutation,
  useGetCecmasMutation, useKiteProfileMutation, useLogoutZerodhaMutation,
  useGetZerodhaHoldingQuery,
  useGetShortTermPositionsQuery,
  useGetOrderHistoryQuery,
  useGetAdminDashboardStatsQuery,
  useGetAngelProfileQuery, useGetClientIdStatusQuery, useUpdateClientIdMutation,useSaveBankDetailsMutation,useGetBankDetailsQuery
} = userApiSlice;
